import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  IN_TRADE_RANGE_BUCKETS,
  buildBucketPerformance,
  getTradeInTradePriceRange,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceByInTradePriceRangeWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceByInTradePriceRangeWidget: React.FC<PerformanceByInTradePriceRangeWidgetProps> = ({ 
  timeRange, 
  size, 
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: IN_TRADE_RANGE_BUCKETS, metric: getTradeInTradePriceRange }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(item.pnl === 0 ? 1 : 2)}%`} />;
};